import React from "react";
import { twMerge } from "tailwind-merge";

/**
 * A choice the guest toggles: a category, a single choice, an extra, a tip.
 * `solid` fills it with the brand color when on; `outline` (for extras) tints it.
 */
const Chip = ({ selected, onClick, variant = "solid", className = "", children, ...rest }) => {
  const on =
    variant === "outline"
      ? "bg-primary-50 text-primary border-primary"
      : "bg-primary text-white shadow-brand border-transparent";
  const off =
    variant === "outline"
      ? "bg-surface text-dark border-secondary-dark"
      : "bg-secondary text-muted border-transparent";
  return (
    <button
      type="button"
      aria-pressed={selected ? "true" : "false"}
      onClick={onClick}
      className={twMerge(
        "h-11 px-4 rounded-md border-[1.5px] text-sm font-medium whitespace-nowrap transition-colors disabled:opacity-40",
        selected ? on : off,
        className
      )}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Chip;
